import React, { useEffect, useState } from "react";
import { Descriptions } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import HeadingBack from "../../component/HeadingBack";
import { DateFormat } from "../../utils";
import { useRights } from "../../hooks/usePermission";
import { fetchOrganizationById } from "../../redux/Services/OrganizationServices";
import FacilitiesSection from "./FacilitiesSection";
import IntegrationsSection from "./IntegrationsSection";
import ApiTokenSection from "./ApiTokenSection";

// Organization details + its facilities
const OrganizationDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const rights = useRights("Users Management");
  const [org, setOrg] = useState(null);

  useEffect(() => {
    fetchOrganizationById(id).then(setOrg);
  }, [id]);

  return (
    <div>
      <HeadingBack title={org?.Name || "Organization"} subHeading={org?.OrganizationId || ""} />

      <div className="p-20">
        <div className="flex align-items-center">
          <h3 className="flex1">Details</h3>
          {rights.Edit && (
            <button
              type="button"
              className="gradient-button w-auto"
              onClick={() => navigate(`/organization/edit/${id}`)}
            >
              Edit
            </button>
          )}
        </div>
        <Descriptions bordered size="small" column={{ xs: 1, md: 2 }} className="mt-10">
          <Descriptions.Item label="Organization ID">{org?.OrganizationId}</Descriptions.Item>
          <Descriptions.Item label="Name">{org?.Name}</Descriptions.Item>
          <Descriptions.Item label="Email">{org?.Email || "-"}</Descriptions.Item>
          <Descriptions.Item label="Mobile">{org?.Mobile || "-"}</Descriptions.Item>
          <Descriptions.Item label="Address">{org?.Address || "-"}</Descriptions.Item>
          <Descriptions.Item label="Status">
            {org ? (org.Status ? "Active" : "Inactive") : ""}
          </Descriptions.Item>
          <Descriptions.Item label="Users">{org?.UserCount ?? "-"}</Descriptions.Item>
          <Descriptions.Item label="Created">{DateFormat(org?.CreatedAt)}</Descriptions.Item>
        </Descriptions>
      </div>

      <div className="p-20">
        <FacilitiesSection organizationId={org?.Id} />
      </div>

      {/* Hold API keys: only users who can edit organizations */}
      {rights.Edit && org?.Id && (
        <div className="p-20">
          <ApiTokenSection organizationId={org.Id} />
        </div>
      )}
      {rights.Edit && org?.Id && (
        <div className="p-20">
          <IntegrationsSection organizationId={org.Id} />
        </div>
      )}
    </div>
  );
};

export default OrganizationDetails;
